/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "local 0.1.0",
    versionChannel: "local",
    buildDate: "2025-10-23T00:34:47.835Z",
    commitHash: "8ce83f2ae81f68828e4cd38889c22bf0380762a9",
};
